'use client';

import React from 'react';

interface SecondaryButtonData {
  title: string;
  url?: string;
  functionality?: string;
  slug?: string;
  target?: string;
}

interface SecondaryButtonProps {
  data: SecondaryButtonData;
  className?: string;
  onClick?: () => void;
  ariaLabel?: string;
  role?: string;
  target?: string;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  data,
  className = '',
  onClick,
  ariaLabel,
  role,
  target,
}) => {
  const buttonUrl = data.url || data.functionality || data.slug || '#';
  const linkTarget = target || data.target;

  const baseClasses = `
    inline-flex items-center justify-center relative px-6 py-2 rounded-lg
    bg-transparent text-theme-primary 
    hover:bg-theme-primary hover:text-white
    transition-all duration-200 
    font-normal text-center
    border-2 border-theme-primary
    overflow-hidden
    hover:shadow-md
  `
    .replace(/\s+/g, ' ')
    .trim();

  const combinedClasses = `${baseClasses} ${className}`;

  if (onClick) {
    return (
      <button
        className={combinedClasses}
        onClick={onClick}
        type="button"
        aria-label={ariaLabel || data.title}
        role={role}
      >
        {data.title}
      </button>
    );
  }

  return (
    <a
      href={buttonUrl}
      target={linkTarget}
      rel={linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
      className={combinedClasses}
      aria-label={ariaLabel || data.title}
      role={role}
    >
      {data.title}
    </a>
  );
};

export default SecondaryButton;
